import { render, staticRenderFns } from "./PropertyReportPreview.vue?vue&type=template&id=afe407ec&scoped=true&"
import script from "./PropertyReportPreview.vue?vue&type=script&lang=ts&"
export * from "./PropertyReportPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe407ec",
  null
  
)

export default component.exports